import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { themes } from "./ThemeProvider.themes";
import { GlobalStyles } from "./ThemeProvider.styled";
var ThemeProvider = function (_a) {
    var chosenTheme = _a.chosenTheme, children = _a.children;
    var theme = !chosenTheme ? themes.original : themes[chosenTheme];
    return (_jsxs(StyledThemeProvider, { theme: theme, children: [_jsx(GlobalStyles, {}), children] }));
};
export default ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map